import SingleCaseStudy from './casestudy'
import frontPage from './front-page'
import page from './page'
import BlogPage from './page-blog'
import CareersPage from './page-careers'
import CitgoPage from './page-citgo'
import ContactPage from './page-contact'
import LeadershipPage from './page-leadership'
import MotechPage from './page-motivation-technologies'
import WorkPage from './page-work'
import single from './single'

export default {
  'front-page': frontPage,
  page,
  'page-blog': BlogPage,
  'page-careers': CareersPage,
  'single-casestudy': SingleCaseStudy,
  'page-work': WorkPage,
  'page-contact': ContactPage,
  'page-citgo': CitgoPage,
  'page-leadership': LeadershipPage,
  'page-motivation-technologies': MotechPage,
  single
}
